import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Target = () => {
    return (
        <div className="teboil-target">
            <FullWrapper>
                <div className="teboil-targetWrapper">
                    <div className="teboil-targetLeft">Цель</div>
                    <div className="teboil-targetRight">
                        Технологически обеспечить выход бренда Teboil на&nbsp;российский рынок
                        онлайн-торговли, расширить географию клиентов с&nbsp;помощью
                        интернет-магазина.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
